import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr, amtStr4Dec } from 'helpers/StringNumberFunction/NumFormatters'
import { ELetterServiceAP } from './ELetterServiceAP/ELetterServiceAP'
import { ELetterServiceAR } from './ELetterServiceAR/ELetterServiceAR'
import { ELetterServiceGP } from './ELetterServiceGP/ELetterServiceGP'
import { ELetterServiceCB } from './ELetterServiceCB/ELetterServiceCB'
import { ELetterServiceGL } from './ELetterserviceGL/ELetterServiceGL'

const moduleParams = (
  accountType: string,
  docType: string,
  previewDetail,
  allpreviewDetail,
  getCompany,
  page,
  pageLength,
  getUsersByAccountAndSoftware,
  ItemIndex
) => {
  let ICStockReqquisition,
    ICStockRecceipt,
    ICStockIssuue,
    ICStockTransfer,
    ICStockTransfreRequisition,
    ICStockAdjustment,
    ICStockCostAdjustment

  let paramVal: any = {
    '[CompanyName]': getCompany[0]?.Name!,
    '[CompanyRegNo]': getCompany[0]?.CompanyRegNo!,
    '[CompanyTIN]': getCompany[0]?.Tin!,
    '[CompanyAddress]': `${getCompany[0]?.Address?.address}
  <br />
  ${
    getCompany[0]?.Address?.country == 'Singapore'
      ? `${getCompany[0]?.Address?.country} ${getCompany[0]?.Address?.postCode}`
      : `${getCompany[0]?.Address?.postCode} ${getCompany[0]?.Address?.city}, ${getCompany[0]?.Address?.state}, ${getCompany[0]?.Address?.country}`
  }`,
    '[CompanySSTNo]': getCompany[0]?.SSTNo!,
    '[CompanyGSTNo]': getCompany[0]?.GSTNo!,
    '[CompanyTelNo]': getCompany[0]?.ContactNo!,
    'src="https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg"': `src = ${getCompany[0]?.Logo?.fileURL}`,
    '[PageNo]': page + 1,
    '[TotalPage]': pageLength,
    '[CreatedBy]': getUsersByAccountAndSoftware?.find(
      x => x?.ID === previewDetail?.createdBy!
    )?.name!,
    '[CreatedDate]': dateFormat(previewDetail?.createdTs!),
    '[ApprovedBy]':
      getUsersByAccountAndSoftware?.find(
        x => x?.ID === previewDetail?.approvedBy!
      )?.name! ?? '',
    '[ApprovedDate]': !!previewDetail?.approvedTs
      ? dateFormat(previewDetail?.approvedTs!)
      : '',
    '[SubmittedBy]': getUsersByAccountAndSoftware?.find(
      x => x?.ID === previewDetail?.submittedBy!
    )?.name!,
    '[SubmittedDate]': !!previewDetail?.submittedTs
      ? dateFormat(previewDetail?.submittedTs!)
      : '',
    [`[ApprovedBy${1}]`]: '',
    [`[ApprovedBy${2}]`]: '',
    [`[ApprovedBy${3}]`]: '',
    [`[ApprovedBy${4}]`]: '',
    [`[ApprovedDate${1}]`]: '',
    [`[ApprovedDate${2}]`]: '',
    [`[ApprovedDate${3}]`]: '',
    [`[ApprovedDate${4}]`]: '',
  }

  if (!!previewDetail?.ApprovalWorkflow) {
    const latestWF = previewDetail?.ApprovalWorkflow[0]
    latestWF?.WorkflowStep?.filter(x => x?.ApprovalStatus === 'APPROVED')?.map(
      (el, i) => {
        const index = i + 1
        paramVal[`[ApprovedBy${index}]`] = !!el?.Name ? el?.Name : ''
        paramVal[`[ApprovedDate${index}]`] = !!el?.ApprovalDT
          ? dateFormat(el?.ApprovalDT)
          : ''
      }
    )
  }

  switch (accountType) {
    case 'cash-book':
      ELetterServiceCB({
        docType,
        previewDetail,
        paramVal,
        ItemIndex,
      })
      break
    case 'account-receivable':
      ELetterServiceAR({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
      })
      break
    case 'account-payable':
      ELetterServiceAP({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
      })
      break
    case '/': // General Purchase
      ELetterServiceGP({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
      })
      break
    case 'general-ledger':
      ELetterServiceGL({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
      })
      break
    case 'inventory-control':
      switch (docType) {
        case 'stock-requisition':
          Object.assign(paramVal, ICStockReqquisition)
          break
        case 'stock-receipt':
          Object.assign(paramVal, ICStockRecceipt)
          break
        case 'stock-issue':
          Object.assign(paramVal, ICStockIssuue)
          break
        case 'stock-transfer':
          Object.assign(paramVal, ICStockTransfer)
          break
        case 'stock-transfer-requisition':
          Object.assign(paramVal, ICStockTransfreRequisition)
          break
        case 'stock-adjustment':
          Object.assign(paramVal, ICStockAdjustment)
          break
        case 'stock-cost-adjustment':
          Object.assign(paramVal, ICStockCostAdjustment)
          break
      }
      break
  }

  return paramVal ?? {}
}

export function groupItemDataForPreview({ templateBody, groupKeys, dataItem }) {
  let parser = new DOMParser()
  let doc = parser.parseFromString(templateBody, 'text/html')
  let element = doc.getElementById('ItemValue')
  const regex = /\[(.*?)\]/g
  const matches = []
  let match

  while ((match = regex.exec(element.innerHTML)) !== null) {
    matches.push(match[1])
  }

  const filteredArr = matches.filter(value => groupKeys.includes(value))

  const groupedData = dataItem.reduce((acc, item) => {
    const key = filteredArr.map(k => item[`${k}`]).join('-')

    if (!acc[key]) {
      acc[key] = { ...item }
    } else {
      acc[key].Quantity += item.Quantity
      acc[key].BaseAmt += item.BaseAmt
      acc[key].TaxAmt += item.TaxAmt
      acc[key].TotalAmt += item.TotalAmt
    }

    return acc
  }, {})

  // Convert the result back to an array
  return Object.values(groupedData) ?? []
}

export function groupItemData(
  element,
  arrItem,
  Itemindex,
  threshold,
  groupKeys,
  sumValueKeys
) {
  const regex = /\[(.*?)\]/g
  const matches = []
  let match

  while ((match = regex.exec(element.innerHTML)) !== null) {
    matches.push(match[1])
  }

  const filteredArr = matches.filter(value => groupKeys.includes(value))

  const groupedItems: any[] = arrItem.reduce((acc, item) => {
    const key = filteredArr.map(k => item[`[${k}]`]).join('-')

    if (!acc[key]) {
      acc[key] = filteredArr.reduce(
        (obj, k) => {
          obj[`[${k}]`] = item[`[${k}]`]
          return obj
        },
        {
          '[Quantity]': 0,
          '[TaxAmt]': 0,
          '[TotalAmt]': 0,
          '[BaseAmt]': 0,
        }
      )
    }

    sumValueKeys?.map(x => {
      acc[key][`[${x?.column}]`] += parseFloat(
        item[`[${x?.column}]`].replace(/,/g, '')
      )
    })

    return acc
  }, {})

  const result = Object.values(groupedItems)
    .filter((x, i) => i >= Itemindex && i + 1 <= Itemindex + 15)
    .map((item, index) => {
      let obj = {
        '[Index]': index + 1 + Itemindex, // Adding index starting from 1
        ...item,
      }
      sumValueKeys?.map(el => {
        obj[`[${el?.column}]`] =
          el?.decimal === 4
            ? amtStr4Dec(item[`[${el?.column}]`])
            : amtStr(item[`[${el?.column}]`])
      })
      return obj
    })

  return result
}

export function extractItemValue(htmlString, arrItem) {
  let parser = new DOMParser()
  let doc = parser.parseFromString(htmlString, 'text/html')
  let element = doc.getElementById('ItemValue')
  let ItemData = arrItem

  // function to replace AllocatedItemValue data
  const replaceAllocatedItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|')
    var regex = new RegExp(keys, 'gi')

    return itemhtml.replace(regex, function(matched) {
      return obj[matched]
    })
  }

  // function to replace ItemValue data
  const replaceItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|')
    var regex = new RegExp(keys, 'gi')

    const DebitAlloc = obj?.subItem ?? []
    let itemdoc = parser.parseFromString(itemhtml, 'text/html')
    let AllocatedItemValue = itemdoc.getElementById('AllocatedItemValue')

    // Condition if have AllocatedItemValue element
    if (AllocatedItemValue) {
      // Replace value for AllocatedItemValue if DebitAlloc have data
      if (DebitAlloc?.length > 0) {
        const alloccontainer = DebitAlloc.map(x =>
          replaceAllocatedItemValue(AllocatedItemValue.innerHTML, x)
        ).join(' ')

        AllocatedItemValue.innerHTML = alloccontainer
      } else {
        // Remove AllocatedItemValue if DebitAlloc does not have data
        AllocatedItemValue.parentNode.removeChild(AllocatedItemValue)
      }

      return itemdoc.documentElement.outerHTML.replace(regex, function(
        matched
      ) {
        return obj[matched]
      })
    } else {
      return itemhtml.replace(regex, function(matched) {
        return obj[matched]
      })
    }
  }

  if (element && ItemData && ItemData?.length > 0) {
    const container = ItemData.map(x =>
      replaceItemValue(element.innerHTML, x)
    ).join(' ')

    element.innerHTML = container

    return doc.documentElement.outerHTML
  }

  return htmlString
}

export function extractAllocItemValue(htmlString, arrItem) {
  let parser = new DOMParser()
  let doc = parser.parseFromString(htmlString, 'text/html')
  let element = doc.getElementById('AllocItemValue')
  let ItemData = arrItem

  const replaceItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|')
    var regex = new RegExp(keys, 'gi')

    return itemhtml.replace(regex, function(matched) {
      return obj[matched]
    })
  }

  if (element && ItemData && ItemData?.length > 0) {
    const container = ItemData.map(x =>
      replaceItemValue(element.innerHTML, x)
    ).join(' ')

    element.innerHTML = container

    return doc.documentElement.outerHTML
  }

  return htmlString
}

export const extractHtmlValue = (
  htmlTemplate,
  accountType,
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  page,
  pageLength,
  getUsersByAccountAndSoftware,
  threshold
) => {
  const Itemindex = threshold * page

  var mapObj: any = moduleParams(
    accountType,
    docType,
    previewDetail,
    allpreviewDetail,
    getCompany,
    page,
    pageLength,
    getUsersByAccountAndSoftware,
    Itemindex
  )

  var keys = Object.keys(mapObj)
    .map(key => key.replace(/[\[\]]/g, '\\$&'))
    .join('|')
  var regex = new RegExp(keys, 'gi')
  let htmlContent = htmlTemplate
  if (!!htmlTemplate) {
    htmlContent = htmlTemplate
      .replace(regex, function(matched) {
        return mapObj[matched]
      })
      .replace(/border-top: 1px dotted #ccc;/g, '')
      .replace(/border-bottom: 1px dotted #ccc;/g, '')

    if (mapObj?.items?.length > 0) {
      htmlContent = extractItemValue(htmlContent, mapObj?.items)
    }
    if (mapObj?.allocItems?.length > 0) {
      htmlContent = extractAllocItemValue(htmlContent, mapObj?.allocItems)
    }
    //  htmlContent = htmlContent.replace(/\[.*?\]/g, '')
  }

  return htmlContent
}
